// src/services/fiscalService.js
import { collection, addDoc, serverTimestamp } from "firebase/firestore";
import { db } from "./firebaseConfig";

/**
 * Salva o lote de emissão fiscal (incluindo IDs retornados pela NotaaS) no Firebase para futuro download do XML.
 */
export const salvarHistoricoFiscal = async (loteEmitido, retornoNotaaS) => {
  try {
    // Aceita qualquer status de sucesso da família 2xx (200, 201, 202, etc.)
    const notasAutorizadas = (retornoNotaaS || []).filter(
      (r) => (r.status >= 200 && r.status < 300) || r.status === 202
    );

    // Se nenhuma nota tiver status de sucesso 2xx
    if (notasAutorizadas.length === 0) {
      const detalhesErro = (retornoNotaaS || [])
        .map((r, i) => {
          const camposTxt = Array.isArray(r.data?.campos) ? ` (${r.data.campos.join(", ")})` : "";
          const motivo =
            (r.data?.message ||
            r.data?.erro ||
            r.data?.erros ||
            r.data?.error ||
            r.raw ||
            `HTTP ${r.status}`) + camposTxt;
          return `Nota ${i + 1}: ${typeof motivo === "object" ? JSON.stringify(motivo) : motivo}`;
        })
        .join(" | ");

      return {
        success: false,
        message: `Nenhuma nota foi autorizada pela NotaaS. ${detalhesErro}`,
        detalhes: retornoNotaaS,
      };
    }

    const historicoRef = collection(db, "historico_notas_fiscais");
    const docData = {
      dataEmissao: serverTimestamp(),
      notasEnviadas: notasAutorizadas.length,
      totalNotasLote: loteEmitido.length,
      retornoNotaaS: retornoNotaaS, // Salva o retorno completo para auditoria e download
      lotePayload: loteEmitido,
    };
    const novoDoc = await addDoc(historicoRef, docData);
    return {
      success: true,
      id: novoDoc.id,
      notasAutorizadas: notasAutorizadas.length,
    };
  } catch (error) {
    console.error("Erro ao salvar histórico fiscal:", error);
    return { success: false, message: error.message };
  }
};
